export function validateBillingDetails(values = {}) {
  const errors = {};
  const isEmpty = (v) => (typeof v === 'string' ? v.trim() === '' : !v);

  if (isEmpty(values.legalName)) {
    errors.legalName = 'Business Name is required';
  }

  const email = values.email || '';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (isEmpty(email)) {
    errors.email = 'Contact Email is required and must be valid';
  } else if (!emailRegex.test(email)) {
    errors.email = 'Contact Email must be valid';
  }

  const phone = (values.phone || '').trim();
  const phoneRegex = /^\+[1-9]\d{1,14}$/;
  if (!isEmpty(phone) && !phoneRegex.test(phone)) {
    errors.phone = 'Phone Number must include country code in international format, e.g. +919876543210';
  }

  const gstin = (values.gstin || '').trim();
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
  if (!isEmpty(gstin) && !gstRegex.test(gstin)) {
    errors.gstin = 'GSTIN must be a valid GSTIN';
  }

  const address = values.address || {};
  if (isEmpty(address.line1)) {
    errors['address.line1'] = 'Address Line 1 is required';
  }
  if (isEmpty(address.city)) {
    errors['address.city'] = 'City is required';
  }
  if (isEmpty(address.state)) {
    errors['address.state'] = 'State is required';
  }

  const pin = (address.pinCode || '').toString();
  const pinRegex = /^\d{6}$/;
  if (!isEmpty(pin) && !pinRegex.test(pin)) {
    errors['address.pinCode'] = 'Pin Code must be a valid 6-digit Indian PIN code';
  }

  return errors;
}

export default validateBillingDetails;
